// extracted by mini-css-extract-plugin
module.exports = {"market-button":"market_market-button__Tpjwo","market-pill-orange":"market_market-pill-orange__f_4Xc"};